import { logException } from 'lib/errors'

export const FINANCING_APPLICATION_STATUS = Object.freeze({
    TEMP: 'TEMP',
    DRAFT: 'DRAFT',
    NEW: 'NEW',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    ACTIVATED: 'ACTIVATED',
    DENIED: 'DENIED',
    CANCELLED: 'CANCELLED',
    EXPIRED: 'EXPIRED',
})

export const TYPE_OF_EMPLOYMENT = Object.freeze({
    FOR_NOW: 'forNow',
    PART_TIME: 'partTime',
    SUBSTITUTE: 'substitute',
    STUDENT: 'student',
    SELF_EMPLOYED: 'selfEmployed',
    UNEMPLOYED: 'unemployed',
    PENSIONER: 'pensioner',
    OTHER: 'other',
})

export const TYPE_OF_EMPLOYMENT_IS_EMPLOYED = Object.freeze([
    TYPE_OF_EMPLOYMENT.FOR_NOW,
    TYPE_OF_EMPLOYMENT.PART_TIME,
    TYPE_OF_EMPLOYMENT.SUBSTITUTE,
])

export const isEmployed = (typeOfEmployment) => {
    return TYPE_OF_EMPLOYMENT_IS_EMPLOYED.includes(typeOfEmployment)
}

export const getStatusColor = (status) => {
    switch (status.toUpperCase()) {
    case FINANCING_APPLICATION_STATUS.DRAFT:
    case FINANCING_APPLICATION_STATUS.NEW:
    case FINANCING_APPLICATION_STATUS.PENDING:
        return 'orange'
    case FINANCING_APPLICATION_STATUS.CANCELLED:
    case FINANCING_APPLICATION_STATUS.DENIED:
    case FINANCING_APPLICATION_STATUS.EXPIRED:
        return 'gray-dark'
    case FINANCING_APPLICATION_STATUS.APPROVED:
    case FINANCING_APPLICATION_STATUS.ACTIVATED:
        return 'green'
    default:
        logException(`Invalid status on getStatusColor: ${status}`)
    }
}

export const getFinancingApplicationPath = (id) => {
    return `/financing/application/${id}`
}

export const getFinancingApplicationEditPath = (id) => {
    return `/financing/application/${id}/edit`
}
